import React, { useEffect, useState } from "react";

import { useFormikContext } from "formik";
import { Delete } from "icons";

import { Button, Typography } from "clearsense-ui/components";
import { Input, Textarea } from "clearsense-ui/components/formik";

const AddVariation = ({
  isEditVariation,
  onVariationClose,
  removeVariation,
  variationIndex,
}) => {
  const { errors, values, setFieldValue } = useFormikContext();
  const [showError, setShowError] = useState(false);
  const [oldVariationValues, setOldVariationValues] = useState(false);

  const handleSave = () => {
    setShowError(true);
    if (!(errors.variations && errors.variations[variationIndex])) {
      onVariationClose();
    }
  };

  const handleCancel = () => {
    if (!isEditVariation) {
      removeVariation(variationIndex);
    } else {
      setFieldValue("variations", oldVariationValues);
    }
    onVariationClose();
  };

  const handleDelete = () => {
    removeVariation(variationIndex);
    onVariationClose();
  };

  useEffect(() => {
    if (isEditVariation) {
      setOldVariationValues(values.variations);
    }
  }, []);

  return (
    <div className="border w-full p-4">
      <Typography className="mb-4" data-cy="variation-form-title">
        {isEditVariation ? "Edit Variation" : "Add a Variation"}
      </Typography>
      <div className="flex flex-col gap-4">
        <Input
          data-cy="variation-name-input-field"
          label="Variation Name"
          name={`variations.${variationIndex}.name`}
          placeholder="Enter variation suffix"
          error={
            showError &&
            errors.variations &&
            errors.variations[variationIndex]?.name
          }
          required
        />
        <Textarea
          data-cy="variation-description-textarea"
          label="Variation Description"
          name={`variations.${variationIndex}.description`}
          placeholder="Enter variation description"
        />
        <div className="flex w-full overflow-auto space-x-2">
          <Button
            label="Save Variation"
            size="small"
            onClick={handleSave}
            data-cy="save-variation-button"
          />
          <Button
            label="Cancel"
            style="secondary"
            onClick={handleCancel}
            data-cy="cancel-variation-button"
            v
          />
          {isEditVariation && (
            <Button
              data-cy="delete-variation-button"
              icon={Delete}
              className="text-red-600"
              style="secondary"
              onClick={handleDelete}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddVariation;
